























































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { ConsultController } from '@/services/request.service';
import { getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';
import fields from '@/fields.config';
import moment, { Moment } from 'moment';
import LocationCascader from '@/components/LocationCascader.vue';
import { DropDownController } from '@/services/request.service';
import { KunshanApplicationController, BaseApplicationController } from '../services/request.service';

@Component({
  components: {
    LocationCascader,
  },
})
export default class StudentDetail extends Vue {
  @Prop() public studentDetailInfo!: any;
  @Prop() public isApp!: any; //判断是不是申请表

  @Prop({ default: true }) public isShow!: boolean;

  public currentYear: string = '';
  public displayYear: string = '';
  public sectionDateList: any = [];
  public moment = moment;
  public config = config;
  public fields = fields;
  public isEdit: boolean = false;
  public isSupportEditMode: boolean = true;
  public visible = false;
  public confirmLoading = false;
  public gradeList: any = [];
  public isAgeInvalid: boolean = false;
  public isBoarding: boolean = true;
  public data: any = {};
  public campusType: number = -1;
  public dataSource: any = [];
  public age: number = 0;
  public siblingsList: Array<any> = [];
  public isHasDefaultSibling: boolean = false;
  public siblingsListsiblings!: Array<any>;
  public sourceIsOther: boolean = false;
  public studentSource: boolean = false;
  public teacherSource: boolean = false;
  public isHasSibling: string | undefined = '';
  public isSiblings: boolean = false;
  // public siblings!:Array<any>
  public getValue(index: number, name: string) {
    const { siblingsList } = this;
    if (siblingsList && siblingsList[index] && siblingsList[index][name] !== null) {
      if (name === 'birthday' && siblingsList[index][name]) {
        return moment(siblingsList[index][name]);
      }
      return siblingsList[index][name];
    }
    return undefined;
  }

  public changeIsHasSibling(e: any): void {
    this.isHasSibling = e.target.value;
    if (this.isHasSibling === 'false') {
      this.siblingsList = [];
    } else {
      this.addSibling();
    }
  }
  public deleteItem(index: number): void {
    this.siblingsList.splice(index, 1);
    const newList = this.siblingsList.slice(0);
    if (newList.length === 0) {
      this.isHasSibling = 'false';
    }
  }
  @Watch('studentDetailInfo', { immediate: true })
  public onStudentDetailInfoChange(newVal): void {
    if (newVal) {
      this.data = {
        ...newVal,
        birthday: moment(newVal.birthday) || undefined,
        enterDate: newVal.enterDate ? moment(newVal.enterDate) : undefined,
        location: [newVal.provinceCode || undefined, newVal.cityCode || undefined, newVal.districtCode || undefined],
        censusLocation: [
          newVal.domicileProvince || undefined,
          newVal.domicileCity || undefined,
          newVal.domicileDistrict || undefined,
        ],
        schoolYearId: [newVal.schoolYearId || undefined, newVal.semesterId || undefined],
      };
      this.siblingsList = newVal.siblings;
      // this.siblingsList=this.siblingsList.map(item => (item.birthday = moment(item.birthday)));
      if (this.siblingsList) {
        this.isHasSibling = this.siblingsList.length > 0 ? 'true' : 'false';
      }
      if (this.data.siblings) {
        this.isSiblings = this.data.siblings.length === 0 ? false : true;
      }
      this.setAge(moment(this.data.birthday));

      if (!this.data.boarding) {
        this.getRightSectionIdByBirthday(moment(this.data.birthday), this.data.schoolYearId);
      } else {
        this.$set(this.data, 'boarding', this.data.boarding ? this.data.boarding : undefined);
      }
    }
  }

  public getGradeAndSectionDateList(): void {
    const isDraft = this.$route.query.isDraft;
    Promise.all([DropDownController.getSectionList(), BaseApplicationController.getSectionDate()]).then(res => {
      this.gradeList = res && res[0].data ? res[0].data : [];
      this.sectionDateList = res[1].data && res[1].data.sectionDateList ? res[1].data.sectionDateList : [];
      this.currentYear = res[1].data && res[1].data.currentSchoolYear;
      // this.displayYear = res[1].data && res[1].data.displaySchoolYear;
      if (isDraft) {
        // this.getDraft();
      }
    });
  }
  public setValue(index: number, name: string) {
    return (e: any) => {
      let v = e;
      if (v && v.target) {
        v = e.target.value;
      }
      if (name === 'name' && v.length > 50) {
        v = v.slice(0, 50);
        this.$message.warning(this.$tc('warningTip.siblingNameInvaild'));
      }
      const newSiblings = this.siblingsList.slice();
      newSiblings[index] = Object.assign({}, newSiblings[index], { [name]: v });
      this.siblingsList = newSiblings;
    };
  }
  public getDraft(): void {
    this.config[this.school].controller.getDraft().then((res: any) => {
      this.data = res.data;
    });
  }
  public addSibling(): void {
    this.siblingsList = this.siblingsList.concat({ id: this.siblingsList.length + 1 });
  }
  // public deleteItem(index: number): void {
  //   this.siblingsList.splice(index, 1);
  // }

  public disabledDate(current: Moment) {
    return current && current > moment().endOf('day');
  }
  public created(): void {
    this.$store.dispatch('getCampusList');
    this.$store.dispatch('getSourceList');
    this.$store.dispatch('getSectionList');
    this.$store.dispatch('getConsultSectionList');
    this.$store.dispatch('getConsultSchoolYearAndSemesterList');
    this.$store.dispatch('getActivityAndChannelList');
    this.$store.dispatch('getCountryWithCodeList');
    this.$store.dispatch('getIdTypeList');
    this.$store.dispatch('getSchoolYearAndSemesterList');
    this.$store.dispatch('getSchoolYearAndSemesterListStudent');

    this.$store.dispatch('getSchoolLibList');
    this.$store.dispatch('getEnglishList');
    this.getGradeList();
    this.getGradeAndSectionDateList();
  }
  public getGradeList(): void {
    DropDownController.getSectionList().then(res => {
      this.gradeList = res.data;
    });
  }
  public handleSourceChange(value: number): void {
    this.data.sourceId = value;
    this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(value) ? true : false;
    this.teacherSource = value === 1280 ? true : false;
    this.studentSource = value === 741 ? true : false;
    this.dataSource = [];

    this.data.sourceExtra = '';
  }
  public onSelect() {}
  public onSearch(searchText: any) {
    if (this.teacherSource === true) {
      DropDownController.getMembersByName(searchText).then(res => {
        //   this.data = res && res.data ? res.data : {};
        // for (var i in this.data) {
        //   this.studentList.push(this.data[i].name);
        // }
        if (res) {
          this.dataSource = [];
          res.data.map(item => {
            if (item.enValue) {
              this.dataSource.push(item.value + item.enValue);
            } else {
              this.dataSource.push(item.value);
            }
          });
        }
        // this.dataSource = res.data
      });
    }
    if (this.studentSource === true) {
      DropDownController.getStudentsByName(searchText).then(res => {
        if (res) {
          this.dataSource = [];
          res.data.map(item => {
            if (item.enValue) {
              this.dataSource.push(item.value + item.enValue);
            } else {
              this.dataSource.push(item.value);
            }
          });
        }
      });
    }
  }
  public ontabChange(value: any) {}
  public submitValues(values: any): void {
    this.isEdit = false;
  }
  public get school() {
    return getSchoolInfo().shortName;
  }
  public getRightSectionIdByBirthday(date: Moment, year: number): void {
    // 选择的申请学年索引值
    let schoolYearIndex = '',
      commendYearIndex = '';
    const schoolYearAndSemesterList = this.$store.state.schoolYearAndSemesterList;
    for (const index in schoolYearAndSemesterList) {
      if (schoolYearAndSemesterList[index].key === year) {
        schoolYearIndex = index;
      }
      if (schoolYearAndSemesterList[index].value === this.currentYear) {
        commendYearIndex = index;
      }
    }
    let newDate = moment(date);
    if (schoolYearIndex < commendYearIndex) {
      let interval = parseInt(commendYearIndex, 10) - parseInt(schoolYearIndex, 10);
      newDate = moment(date).add(interval, 'years');
    } else if (schoolYearIndex > commendYearIndex) {
      let interval = parseInt(schoolYearIndex, 10) - parseInt(commendYearIndex, 10);
      newDate = moment(date).subtract(interval, 'years');
    }
    // 获取sectionDateList对应的sectionId索引值
    let sectionIdIndex: string = '';
    for (const index in this.sectionDateList) {
      const item = this.sectionDateList[index];
      if (moment(newDate).isBetween(moment(item.timeStart), moment(item.timeEnd), undefined, '[)')) {
        sectionIdIndex = index;
      }
    }
    if (sectionIdIndex !== '') {
      // 根据学年索引值和推荐的sectionId索引值计算正确的sectionId和是否可住宿flag
      const rightSectionIndex = Number(sectionIdIndex);
      const rightSectionId = this.sectionDateList[rightSectionIndex].sectionId;
      this.isBoarding = this.sectionDateList[rightSectionIndex].enableBoardingFlag;
      this.isAgeInvalid = false;
      this.campusType = this.sectionDateList[rightSectionIndex].sectionType;
      this.getRightCampusIdByCountryId();
      this.$set(this.data, 'sectionId', rightSectionId);
      this.$set(this.data, 'boarding', this.data.boarding === !this.isBoarding ? false : this.data.boarding);
      // this.data.sectionId = rightSectionId;
      // this.data.boarding = !this.isBoarding ? 'false' : undefined;
      // this.$refs.studentFormep1Form.setFieldsValue({
      //   sectionId: rightSectionId,
      //   boarding: !this.isBoarding ? 'false' : undefined,
      // });
    } else {
      // 不合法
      this.isAgeInvalid = true;
      this.campusType = -1;

      this.$set(this.data, 'sectionId', undefined);
      this.$set(this.data, 'campusId', undefined);

      // this.data.sectionId = undefined;
      // this.data.campusId = undefined;

      // this.$refs.studentFormep1Form.setFieldsValue({ sectionId: undefined, campusId: undefined });
    }
  }
  public handleNationalityChange(value: number, option: any): void {
    this.getRightCampusIdByCountryId(value);
  }
  public getRightCampusIdByCountryId(value?: number): void {
    const countryId = value || this.data.countryId;
    if (countryId && this.campusType !== -1) {
      const itemOptions = this.$store.state.campusList.filter((item: any) => item.sectionType === this.campusType);
      if (itemOptions && itemOptions.length > 1) {
        let itemTemp = itemOptions.filter((item: any) => item.campusType === 81)[0];
        if (countryId !== 1 && countryId !== 86 && countryId !== 114 && countryId !== 190) {
          itemTemp = itemOptions.filter((item: any) => item.campusType === 82)[0];
        }
        const schoolId = itemTemp.key;
        // this.data.campusId = schoolId;
        this.$set(this.data, 'campusId', schoolId);
      } else if (itemOptions && itemOptions.length === 1) {
        // this.data.campusId = itemOptions[0].key;
        this.$set(this.data, 'campusId', itemOptions[0].key);
      }
    } else {
      // this.data.sectionId = undefined;
      // this.data.campusId = undefined;
    }
  }
  public setAge(birthday: any): void {
    let age = moment().year() - birthday.year();
    if (birthday.isBefore(birthday.year() + '-09-01')) {
      age += 1;
    }
    this.age = age;
  }
  public handleYearChange(value: number, option: any): void {
    const birthday = this.data.birthday;
    if (birthday && value) {
      this.getRightSectionIdByBirthday(birthday, value[0]);
    } else {
      this.isAgeInvalid = false;
      this.campusType = -1;
      this.$set(this.data, 'sectionId', undefined);
      this.$set(this.data, 'campusId', undefined);
      // this.data.sectionId = undefined;
      // this.data.campusId = undefined;
    }
  }
  public get fieldsType() {
    return this.school === 'kcscd' ? 'kcscd' : 'default';
  }
  @Watch('data', { immediate: true })
  public setFormValue() {
    if (this.data) {
      this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(this.data.sourceId) ? true : false;
      this.teacherSource = this.data.sourceId === 1280 ? true : false;
      this.studentSource = this.data.sourceId === 741 ? true : false;
    }
  }
  public showModal() {
    this.visible = true;
    this.getRightSectionIdByBirthday(moment(this.data.birthday), this.data.schoolYearId[0]);

    // this.data.schoolYearId = this.data.schoolYearId;

    //  this.schoolYearId: this.data.schoolYearId[0],
    //  this.semesterId: this.data.schoolYearId[1],
  }
  public handleCancel() {
    this.$emit('refresh');
    this.visible = false;
  }
  public handleSubmit() {
    if (!this.checkSiblings()) {
      this.$message.error(this.$tc('applicationForm.checkSibling'));
    } else {
      this.confirmLoading = true;
      const form = this.$refs.studentForm as any;
      form.validate(valid => {
        if (valid) {
          const request = {
            ...this.data,
            birthday: moment(this.data.birthday).valueOf(),
            provinceCode: this.data.location[0],
            cityCode: this.data.location[1],
            districtCode: this.data.location[2],
            domicileProvince: this.data.censusLocation[0],
            domicileCity: this.data.censusLocation[1],
            domicileDistrict: this.data.censusLocation[2],
            schoolYearId: this.data.schoolYearId[0],
            semesterId: this.data.schoolYearId[1],
            siblings: this.siblingsList,
          };
          KunshanApplicationController.updateStudent(request)
            .then(() => {
              this.$message.success(this.$tc('changeSuccess'));
              this.$emit('refresh');
            })
            .finally(() => {
              this.visible = false;
              this.confirmLoading = false;
            });
        } else {
          this.confirmLoading = false;
        }
      });
    }
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public get rules() {
    return {
      name: [{ message: this.$tc('warningTip.nameInvaild'), max: 50, min: 1, whitespace: true }],
      enName: [{ message: this.$tc('warningTip.enNameInvaild'), pattern: /^[a-zA-Z\s]{1,50}$/, whitespace: true }],
      pinyinLastName: [
        {
          required: true,
          message: this.$tc('warningTip.pinyinNameInvaild'),
          pattern: /^[a-zA-Z\s]{1,50}$/,
          whitespace: true,
        },
      ],
      pinyinFirstName: [
        {
          required: true,
          message: this.$tc('warningTip.pinyinNameInvaild'),
          pattern: /^[a-zA-Z\s]{1,50}$/,
          whitespace: true,
        },
      ],
      address: [{ required: true, message: this.$tc('warningTip.nameInvaild'), max: 50, min: 1, whitespace: true }],
      pinyinName: [
        {
          required: true,
          message: this.$tc('warningTip.pinyinNameInvaild'),
          pattern: /^[a-zA-Z\s]{1,50}$/,
          whitespace: true,
        },
      ],
      gender: [{ required: true, message: this.$tc('pleaseSelect') }],
      birthday: [{ required: true, message: this.$tc('pleaseSelect') }],
      idType: [{ required: true, message: this.$tc('pleaseSelect') }],
      campusId: [{ required: true, message: this.$tc('pleaseSelect') }],
      sectionName: [{ required: true, message: this.$tc('pleaseSelect') }],
      parentEnglishCommunicationFlag: [{ required: true, message: this.$tc('pleaseSelect') }],
      selector: [{ required: true, message: this.$tc('pleaseSelect') }],
      countryId: [{ required: true, message: this.$tc('pleaseSelect') }],
      sourceId: [{ required: true, message: this.$tc('pleaseSelect') }],

      idNumber: [
        { required: true, message: this.$tc('warningTip.idNumberInvaild'), max: 50, min: 1, whitespace: true },
      ],
      location: [{ required: true, validator: this.locationValidator, trigger: 'blur' }],
      censusLocation: [{ required: true, validator: this.censusLocationValidator, trigger: 'blur' }],
      domicileAddress: [
        { required: true, message: this.$tc('warningTip.nameInvaild'), max: 50, min: 1, whitespace: true },
      ],
      schoolYearId: [{ required: true, message: this.$tc('pleaseSelect') }],
      boarding: [{ required: true, message: this.$tc('pleaseSelect') }],
      english: [{ required: true, message: this.$tc('pleaseSelect') }],
      schoolBus: [{ required: true, message: this.$tc('pleaseSelect') }],

      schoolNowExtra: [
        { required: true, min: 1, max: 50, whitespace: true, message: this.$tc('warningTip.schoolNowExtraInvaild') },
      ],
      interest: [{ required: true, message: this.$tc('warningTip.contentNotEmpty') }],
      achievement: [{ required: true, message: this.$tc('warningTip.contentNotEmpty') }],
      siblingsName: [{ message: this.$tc('warningTip.nameInvaild'), max: 50, min: 1, whitespace: true }],
      siblingsGender: [{ required: true, message: this.$tc('pleaseSelect') }],
      siblingsBirthday: [{ required: true, message: this.$tc('pleaseSelect') }],
      siblingsSchoolNowExtra: [
        { required: true, min: 1, max: 50, whitespace: true, message: this.$tc('warningTip.schoolNowExtraInvaild') },
      ],
    };
  }

  public onDateOfBirthChange(date: any, dateString: string) {
    if (date) {
      this.setAge(date);
      const year = this.data.schoolYearId;

      if (year) {
        this.getRightSectionIdByBirthday(date, year[0]);
      } else {
        this.isAgeInvalid = false;
        this.campusType = -1;
        this.$set(this.data, 'sectionId', undefined);
      }
    } else {
      this.isAgeInvalid = false;
      this.campusType = -1;
      this.$set(this.data, 'sectionId', undefined);
      this.$set(this.data, 'campusId', undefined);
      // this.data.sectionId = undefined;
      // this.data.campusId = undefined;
    }
  }
  public get fieldNames() {
    return { label: this.locale === 'zh' ? 'value' : 'enValue', value: 'key', children: 'children' };
  }
  public handleSchoolNowChange(value: string, option: any): void {
    const schoolNowName = option.componentOptions.children[0].text.trim();
    this.studentDetailInfo.studySchoolIsOther = schoolNowName === '其他' || schoolNowName === 'Other' ? true : false;
  }
  public openFile(resourceUrl: string): void {
    window.open(resourceUrl);
  }

  public censusLocationValidator(rule, value, callback) {
    if (!value.length) {
      callback(this.$tc('warningTip.addressInvaild'));
    }
    if (!this.data.domicileAddress || this.data.domicileAddress.length < 1 || this.data.domicileAddress.length > 50) {
      callback(this.$tc('warningTip.addressInvaild'));
    }
    callback();
  }
  public locationValidator(rule, value, callback) {
    if (!value.length) {
      callback(this.$tc('warningTip.addressInvaild'));
    }
    if (!this.data.address || this.data.address.length < 1 || this.data.address.length > 50) {
      callback(this.$tc('warningTip.addressInvaild'));
    }
    callback();
  }
  public validateLocation() {
    const form = this.$refs.studentForm as any;
    form.validateField(['location']);
  }
  public validateDomicileAddress() {
    const form = this.$refs.studentForm as any;
    form.validateField(['censusLocation']);
  }
  public checkSiblings(): boolean {
    let flag = true;
    this.siblingsList.forEach((item: any) => {
      if (config[this.school].schoolId !== 1 && config[this.school].schoolId !== 3) {
        if (
          !item.siblingStudentId &&
          (!item.name || item.gender === undefined || !item.birthday || !item.schoolNowExtra)
        ) {
          flag = false;
        }
      } else {
        if (
          !item.siblingStudentId &&
          (!item.name || item.gender === undefined || !item.birthday || item.inSchool === undefined)
        ) {
          flag = false;
        }
      }
    });
    return flag;
  }
}
